var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.id == 43)?_c('standard-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            parameter: this.parameter,
            errMsg: this.errMsg,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
                data: this.errMsg,
                isErr: this.isErr
            }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }